<template>
  <div class="formInputWrapper">
    <input
        v-if="!rows"
        class="formInput"
        :class="{ 'formInput--error': error }"
        :type="type"
        :value="modelValue"
        :autocomplete="autocomplete"
        :disabled="disabled"
        @input="inputHandler"
    />
    <textarea
        v-else
        class="formInput"
        :class="{ 'formInput--error': error }"
        rows="rows"
        :value="modelValue"
        style="{'height': height} "
        @input="inputHandler"
    />
    <div v-if="error" class="formInputWrapper__error">{{ error }}</div>
  </div>
</template>

<script>

export default {
  name: "FormInput",
  props: ['modelValue', 'rows', 'height', 'autocomplete', 'error', 'disabled', 'nameOnly', 'type'],
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    function inputHandler(e) {
      if (props.nameOnly) {
        e.target.value =  e.target.value.replace(/[^a-zA-Zа-яёА-ЯЁ\s-]/g, '')
      }
      emit('update:modelValue', e.target.value)
    }

    return {inputHandler}
  }
}
</script>


<style scoped lang="scss">
.formInputWrapper {
  width: 100%;

  &__error {
    color: var(--cd-danger);
    font-size: 12px;
    padding: 4px 20px 0;
  }
}

.formInput {
  width: calc(100% - 40px);
  display: inline-block;
  gap: 10px;
  opacity: 1;
  border-radius: 20px;
  padding: 5px 20px;
  background: var(--cd-field-bg);
  color: var(--cd-field-color);
  border: 1px solid var(--cd-field-border);
  height: 48px;

  &::placeholder {
    color: var(--cd-field-color-disabled);
    opacity: 1;
  }

  &:focus {
    outline: none;
    border-color: var(--cd-base-green);
    box-shadow: 0 0 5px rgba(98, 192, 100, 0.3);
  }

  &--error {
    border-color: var(--cd-danger) !important;
  }

  textarea {
    resize: none;
  }
}

</style>
